/*
 * Sectors collage: photos settle first and stay deep; notes follow
 * in the foreground with a stronger parallax throw.
 */

const STAGE = '[data-sectors]'
const LAYER = '[data-sectors-layer]'
const SHIFT = '[data-sectors-shift]'

function observe(elements, options) {
	if (!elements.length) return

	if (!('IntersectionObserver' in window)) {
		elements.forEach((el) => el.classList.add('is-inview'))
		return
	}

	const observer = new IntersectionObserver((entries) => {
		entries.forEach((entry) => {
			entry.target.classList.toggle('is-inview', entry.isIntersecting)
		})
	}, options)

	elements.forEach((el) => observer.observe(el))
}

function reveal(layers) {
	const photos = layers.filter((el) => el.getAttribute('data-sectors-layer') === 'photo')
	const cards = layers.filter((el) => el.getAttribute('data-sectors-layer') === 'card')

	observe(photos, { rootMargin: '0px 0px -4% 0px', threshold: 0.08 })
	observe(cards, { rootMargin: '0px 0px -8% 0px', threshold: 0.1 })
}

function parallax(stage, shifts) {
	const update = () => {
		const rect = stage.getBoundingClientRect()
		const viewport = window.innerHeight
		const mid = rect.top + rect.height / 2
		const offset = (viewport / 2 - mid) / viewport

		shifts.forEach((el) => {
			const depth = parseFloat(el.getAttribute('data-depth')) || 0
			el.style.transform = `translate3d(0, ${(offset * depth).toFixed(2)}px, 0)`
		})
	}

	let ticking = false
	const onScroll = () => {
		if (ticking) return
		ticking = true
		requestAnimationFrame(() => {
			update()
			ticking = false
		})
	}

	window.addEventListener('scroll', onScroll, { passive: true })
	window.addEventListener('resize', onScroll, { passive: true })
	update()
}

export default function initSectors() {
	const stage = document.querySelector(STAGE)
	if (!stage) return

	const layers = Array.from(stage.querySelectorAll(LAYER))
	const shifts = Array.from(stage.querySelectorAll(SHIFT))

	if (layers.length) reveal(layers)

	if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return
	if (!shifts.length) return

	parallax(stage, shifts)
}
